import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const AnchorIcon = styled.a`
  font-size: 0.6em;
  margin-left: -2em;
  position: absolute;
  color: ${theme.colors.darkBlues[90]}
`